import Join from './Join.jsx';

export default Join;
